import Rest from '../Rest';

export default class ProviderService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = '/providers';
    
	async create(data) {

        return await this.post('/', data)

    }

	async update(data) {
		
        return await this.put('/', data);    
		
    }

	async getMyData() {
		
		return await this.get('/profile/me');

    }
    
    async getDashData(dashData) {

        let url

        if (dashData.initDate && dashData.endDate) url = `/dashData/${dashData.id}?initDate=${dashData.initDate}&endDate=${dashData.endDate}`
        else url = `/dashData/${dashData.id}`
		
		return await this.get(url);
	
    }

}
